export interface LeadTag {
  id: string;
  name: string;
  color: string;
}

export interface ContactGroup {
  id: string;
  workspace_id: string;
  name: string;
  type?: string;
  description?: string;
  website?: string;
  industry?: string;
  size?: string;
  metadata?: any;
  created_at: string;
  updated_at?: string;
}

export interface LeadGroupMembership {
  id: string;
  lead_id: string;
  group_id: string;
  role?: string;
  department?: string;
  is_primary: boolean;
  metadata?: any;
  created_at: string;
  group?: ContactGroup;
}

export interface SalesFunnel {
  id: string;
  workspace_id: string;
  name: string;
  description?: string;
  color: string;
  is_default: boolean;
  order_index: number;
  created_at: string;
  updated_at?: string;
  integration_id?: string | null;
}

export interface LeadFunnelMembership {
  id: string;
  lead_id: string;
  funnel_id: string;
  stage: string;
  order_index: number;
  created_at: string;
}

export interface Lead {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  stage: string;
  notes?: string;
  assigned_agent_id?: string;
  created_at: string;
  updated_at?: string;
  current_appointment_date?: string;
  current_appointment_id?: string;
  metadata?: any;
  tags?: LeadTag[];
  channel?: string | null;
  funnel_id?: string;
  external_id?: string | null;
  groups?: LeadGroupMembership[];
  assigned_member_id?: string;
  assigned_member_ids?: string[];
  order_index?: number;
  workspace_id?: string;
}

export interface Stage {
  id: string;
  name: string;
  slug: string;
  color: string;
  order_index: number;
  funnel_id?: string;
}

export interface GroupStage {
  id: string;
  group_id: string;
  name: string;
  slug: string;
  color: string;
  order_index: number;
  created_at?: string;
  updated_at?: string;
}

export const TAG_COLORS = [
  { name: 'Azul', value: 'bg-blue-500' },
  { name: 'Verde', value: 'bg-green-500' },
  { name: 'Vermelho', value: 'bg-red-500' },
  { name: 'Amarelo', value: 'bg-yellow-500' },
  { name: 'Roxo', value: 'bg-purple-500' },
  { name: 'Rosa', value: 'bg-pink-500' },
  { name: 'Laranja', value: 'bg-orange-500' },
  { name: 'Cinza', value: 'bg-gray-500' },
  { name: 'Ciano', value: 'bg-cyan-500' },
  { name: 'Índigo', value: 'bg-indigo-500' },
];

export const GROUP_TYPES = [
  { value: 'empresa', label: 'Empresa' },
  { value: 'familia', label: 'Família' },
  { value: 'parceiro', label: 'Parceiro' },
  { value: 'fornecedor', label: 'Fornecedor' },
  { value: 'outro', label: 'Outro' },
];

export const COMPANY_SIZES = [
  { value: 'micro', label: 'Microempresa (1-9)' },
  { value: 'pequena', label: 'Pequena (10-49)' },
  { value: 'media', label: 'Média (50-249)' },
  { value: 'grande', label: 'Grande (250+)' },
];
